import { Auth0Client } from '@auth0/auth0-spa-js';

/**
 * Logs the user out and clears cookies.
 * @async
 * @returns {Promise<void>}
 */
export const logoutWrapper = async (
  auth0Client: Auth0Client | null,
  returnUrl: string
): Promise<void> => {
  await auth0Client?.logout({
    logoutParams: {
      returnTo: returnUrl,
    },
  });
};
